<template>
  <div class="pages">
    <div class="pageContent settingPage">
      <div class="setting-box">
        <div class="goBack" @click="$router.push('personal')">
          <img src="@/assets/img/goBack_btn_black.svg" alt=""/>
        </div>
        <div class="menu-box notify-menu-box">
          <div class="menu-item" v-for="item in notifies" :key="item.id" @click.stop="$router.push('notify/' + item.id)">
            <div class="header">
              <div class="title" :red-point="!item.isRead">{{$t1(item, 'type')}}</div>
              <div class="tag" :class="'tag-' + tagColorDict[item.level]"><div class="tiny-text">{{tagDict[item.level]}}</div></div>
            </div>
            <div class="content">
              {{$t1(item, 'message')}}
            </div>
            <div class="date">{{item.createTime}}</div>
          </div>
        </div>
      </div>
      <div class="no-more">{{ notifies && notifies.length > 0 ? $t3('没有更多数据了', 'No More Information') : $t3('暂无数据', 'No Data') }}</div>
    </div>
  </div>
</template>
  
<script>

import { getNotifyList } from '@/api/notify'

export default {
  name: 'setting',
  data () {
    return {
      tagDict: [
        this.$t3('系统通知', 'APP notifications'),
        this.$t3('常规通知', 'Regular'),
        this.$t3('重要通知', 'Important')
      ],
      tagColorDict: ['gray', 'blue', 'orange'],
      notifies: []
    }
  },
  created () {
    this.getNotifyList()
  },
  methods: {
    getNotifyList () {
      getNotifyList().then(res => {
        this.notifies = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-box {
  background: #FFF;
}
.pages .pageContent.settingPage .notify-menu-box {
  .menu-item {
    flex-wrap: wrap;
    height: auto;
    padding: 15px 0;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 26px;
      .title {
        font-size: 17px;
        font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #000409;
        position: relative;
        text-align: left;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow-y: hidden;
        padding-right: 4px;
        &[red-point=true]::after {
          content: '';
          width: 8px;
          height: 8px;
          background: #FB5353;
          border: 1px solid #FFFFFF;
          box-sizing: border-box;
          position: absolute;
          border-radius: 50%;
          right: 0;
          top: 2px;
        }
      }
      .tag {
        background: rgba(107,143,255,0.04);
        border-radius: 2px;
        border: 1px solid rgba(107,143,255,0.5);
        font-size: 11px;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #6B8FFF;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        height: 20px;
        flex-shrink: 0;
        margin-left: 12px;
        .tiny-text {
          font-size: 12.64px;
          transform: scale(0.8);
        }
        &.tag-orange {
          background: rgba(255,151,85,0.04);
          border: 1px solid rgba(234,117,42,0.5);
          color: #EA752A;
        }
        &.tag-gray {
          background: rgba(150,152,155,0.04);
          border: 1px solid rgba(150,152,155,0.5);
          color: #96989B;
        }
      }
    }
    .content {
      text-align: left;
      font-size: 14px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #5D626B;
      line-height: 22px;
      margin-top: 2px;
      overflow: hidden;				//溢出内容隐藏
      text-overflow: ellipsis;		//文本溢出部分用省略号表示
      display: -webkit-box;			//特别显示模式
      -webkit-line-clamp: 2;			//行数
      line-clamp: 2;					
      -webkit-box-orient: vertical;	//盒子中内容竖直排列
    }
    .date {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      height: 22px;
      font-size: 12px;
      font-family: Helvetica;
      color: #96989B;
      margin-top: 10px;
    }
  }
}
.no-more {
  margin-top: 15px;
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #96989B;
  line-height: 20px;
}
</style>